module.exports = {
          srcSet: __webpack_public_path__ + "8a8f076c448b823ec4b523333fc6d1b6-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "8a8f076c448b823ec4b523333fc6d1b6-2336.png",width: 2336,height: 496}],
          src: __webpack_public_path__ + "8a8f076c448b823ec4b523333fc6d1b6-2336.png",
          toString:function(){return __webpack_public_path__ + "8a8f076c448b823ec4b523333fc6d1b6-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ABpRN/wqZUn+KWxL/SVtSf0AYzH9hVNN/v9Vev9XSjv9WltC/glIJ/oADCgb/BAtH/4NLR7+DSwd/gIrGv45IR7+lzZD/mBKR/7BO0P/elpN+5tuI0xrLyEMAAAAAElFTkSuQmCC",
          width: 2336,
          height: 496
        }